import InfoBar from './components/InfoBar/InfoBar';
import Premises from './components/Premises/Premises';
import Map from './components/Map/Map';
import { FC, useEffect } from 'react';
import viewCounterController from '../../Api/viewCountController';
import Layout from '../../components/layout/Layout';
import ProducersSlider from './components/ProducersSlider';
import HomePageGallery from './components/HomePageGallery';
import { tokenController } from '../../Api/tokenController';


interface HomePageProps {

}


const HomePage: FC<HomePageProps> = () => {

    const addCount = async () => {
        let mode = 'client';
        try {
            var config = require('../../config');
            mode = config.mode || 'client';
        } catch {
          
        }
        if (mode === 'development') return
        const today = new Date();
        const day = today.getDate().toString().padStart(2, "0");
        const month = (today.getMonth() + 1).toString().padStart(2, "0");
        const year = today.getFullYear().toString();

        const formattedDate = `${day}-${month}-${year}`;

        if ((localStorage.getItem('LastVisit') !== formattedDate
            || !localStorage.getItem('LastVisit'))
            && !tokenController()) {
            localStorage.setItem('LastVisit', formattedDate)
            await viewCounterController.newView();
        }
    }

    useEffect(() => {
        addCount();
    }, [])

    return (
        <Layout title='UFO Meble'>

            <HomePageGallery />

            <InfoBar />

            <ProducersSlider />

            <Premises />

            <Map />

        </Layout>
    )
}

export default HomePage;
